import React, { useContext, useEffect } from 'react';
import { View } from 'react-native';
import { Controller } from 'react-hook-form';
import { DateTime } from 'luxon';

import ClientContext from 'app/src/contexts/ClientContext';
import { Text } from 'app/src/styles';

import Input, { Field, FieldLabel } from './inputs';

export const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const nameToLabel = name => (
  name.match(/^[a-z]+|[A-Z][a-z]*/g).map(word => (
    word[0].toUpperCase() + word.substr(1).toLowerCase()
  )).join(' ')
);

export const defaultValues = ({ fields, resource }) => {
  const values = {};

  if (resource) {
    values.id = resource.id;
  }

  Object.keys(fields).forEach(name => {
    if (name.endsWith('Id')) {
      const associationName = name.substring(0, name.length - 2)
      values[name] = (resource || {})[associationName]?.id || '';
    } else if (name.includes('.') && resource) {
      values[name.split('.')[0]] = resource[name.split('.')[0]];
    } else {
      if ('date' === fields[name].type && !window.location) {
        if ((resource || {})[name]) {
          values[name] = DateTime.fromISO(resource[name]).toJSDate();
        } else {
          values[name] = new Date();
        }
      } else {
        values[name] = (resource || {})[name] || '';
      }
    }
  });

  return values;
};

export const prepareInput = (input, fields) => {
  Object.keys(fields).forEach(name => {
    const field = fields[name];

    if (['Int', 'int'].includes(field.type)) {
      const intValue = String(input[name] || '').replace(/[^-\d\.]/g, '');
      input[name] = '' === intValue ? null : parseInt(intValue);
    }

    if ('null' === field.blank && !input[name]) {
      input[name] = null
    }

    if ('boolean' === field.type) {
      input[name] = !!input[name];
    }

    if ('datetime' === field.type) {
      if (input[name]) {
        input[name] = DateTime.fromISO(input[name]).toISO();
      } else {
        input[name] = null;
      }
    }
  });

  return input;
};

export const Fields = ({ fields, control, errors, setValue }) => {
  return (
    Object.keys(fields).map((name, fieldIndex) => {
      const field = fields[name];

      if ('hidden' === field.type) { return null; }

      const generalInputProps = {
        name,
        label: (field.label || nameToLabel(name)),
        hint: field.hint,
        docs: field.docs,
        rules: field.rules,
        control,
        errors,
        setValue,
        fieldIndex,
      };

      if (field.select) {
        return (
          <Input.Picker
            key={name}
            options={field.select}
            {...generalInputProps}
          />
        );
      } else if ('boolean' === field.type) {
        return (
          <Input.Switch key={name} {...generalInputProps} />
        );
      } else if ('date' === field.type) {
        return (
          <Input.Date key={name} {...generalInputProps} />
        );
      } else if ('datetime' === field.type) {
        return (
          <Input.Date key={name} mode="datetime" {...generalInputProps} />
        );
      } else if ('button' === field.type) {
        return (
          <Input.ButtonPicker
            key={name}
            options={field.options}
            add={field.add}
            {...generalInputProps}
          />
        );
      } else {
        return (
          <Input.Text key={name} {...generalInputProps} {...field.inputProps} />
        );
      }
    })
  );
};
